import { io } from "socket.io-client";

export const getWebSocketURL = () => {
    const env = process.env.REACT_APP_STREAM_API_ENV;
    switch (env) {
        case "local":
            return "ws://localhost:5001";
        case "development":
            return "wss://core-api-dev.intraverse.com"; // "http://localhost:5001";
        case "staging":
            return "wss://core-api-staging.intraverse.com";
        case "production":
            return "wss://core-api.intraverse.com";
        default:
            return "http://localhost:5001";
    }
};

console.log("getWebSocketURL:", getWebSocketURL());

export const socket = io(getWebSocketURL(), {
    transports: ["websocket"],
    autoConnect: true, // Do not auto-connect initially
});

export const sendSocketMessage = (event, roomId, userId, action, payload) => {
    if (!socket || typeof socket.emit !== "function") {
        console.log("Socket is not properly initialized.");
        return;
    }

    if (event === "joinRoom" || event === "leaveRoom") {
        if (!roomId || !userId) {
            console.log("Missing roomId or userId. Cannot proceed.");
            return;
        }
    }

    if (!socket.connected) {
        console.log("WebSocket is not connected. Retrying...");

        socket.connect();

        socket.once("connect", () => {
            console.log("Reconnected. Resending event:", event);
            // sendSocketMessage(event, roomId, userId, action, payload);
        });

        return;
    }

    switch (event) {
        case "joinRoom":
            socket.emit("joinRoom", roomId, userId, (response) => {
                if (response?.success) {
                    console.log(`Successfully joined room: ${roomId}.`);
                } else {
                    console.log("Failed to join room:", response);
                }
            });
            break;

        case "leaveRoom":
            socket.emit("leaveRoom", roomId, userId, (response) => {
                if (response?.success) {
                    console.log(`Successfully left room: ${roomId}.`);
                } else {
                    console.log("Failed to leave room:", response);
                }
            });
            break;

        case "broadcastAction":
            console.log("Broadcasting action: ", payload);
            socket.emit("broadcastAction", payload, (response) => {
                console.log("BroadcastAction Response:", response);
            });
            break;

        case "system_message":
            socket.emit("system_message", payload, (response) => {
                if (response?.success) {
                    console.log(`Successfully sent system message: ${payload}.`);
                } else {
                    console.log("Failed to send system message:", response);
                }
            });
            break;
        case "RPMAvatarEvent":
            console.log("Sending RPMAvatarEvent:", userId, action, payload);
            if (!userId || !action) {
                console.log("Missing userId or action. Cannot proceed with RPMAvatarEvent.");
                return;
            }
            socket.emit("RPMAvatarEvent", userId, action, payload.data, (ack) => {
                console.log("RPMAvatarEvent for avatar (sent to unity):", ack);
            });
            break;
        default:
            console.log("Invalid event type:", event);
    }
};
